import React from 'react';
import './panels.css';

import cardTomato from '../../../img/Home/panels/card-tomato.png';
import cardAmber from '../../../img/Home/panels/card-amber.png';
import cardViolet from '../../../img/Home/panels/card-violet.png';
import cardPool from '../../../img/Home/panels/card-pool.png';
import overlayNewspapers from '../../../img/Home/panels/overlay-newspapers.png';
import overlayMarker from '../../../img/Home/panels/overlay-marker.png';
import overlaySwishViolet from '../../../img/Home/panels/overlay-swish-violet.png';
import overlayLego from '../../../img/Home/panels/overlay-lego.png';

// One structure, four data rows. base/overlay = the two composite layers;
// ow/ox/oy = the overlay PNG's width and the colour frame's top-left pixel
// (see panels.css for how the calc() aligns them). Copy is Lorem Ipsum.
const PANELS = [
  {
    id: 'collect',
    base: cardTomato,
    overlay: overlayNewspapers,
    ow: 1647, ox: 350, oy: 232,
    title: 'Start with news clients care about',
    body:
      'Busy professionals worry about missing what matters. They will trust those who help alleviate this anxiety. ' +
      'Stedili records key stories with a click of a button.',
  },
  {
    id: 'highlight',
    base: cardAmber,
    overlay: overlayMarker,
    ow: 1459, ox: 202, oy: 146,
    title: 'The hook is always small.',
    body:
      'Our smart extractor automatically picks up key sentences. Stedili helps to ' +
      'select and reorder the bits that matter. Instead of drowning in text, it helps you choose what stays for keeps.',
  },
  {
    id: 'draft',
    base: cardViolet,
    overlay: overlaySwishViolet,
    ow: 1514, ox: 233, oy: 201,
    title: 'An editor that writes with a swish',
    body:
      'Professionals do not put one word after another. They build up ideas, whose basic unit is a paragraph. ' +
      'Using a drag-and-drop interface, Stedili helps you write in whole paragraphs.',
  },
  {
    id: 'assemble',
    base: cardPool,
    overlay: overlayLego,
    ow: 1406, ox: 203, oy: 110,
    title: 'Build separates into a narrative',
    body:
      'Effective thought leadership weaves facts into a wider argument. Stedili helps you do the same, ' +
      'connecting factual fragments into whole narratives.',
  },
];

const Panels = () => (
  <div className="sd-panels">
    {PANELS.map((p, i) => {
      // even index → image on the right (text first); odd → image on the left.
      const imageRight = i % 2 === 0;

      const text = (
        <div className="sd-card-text" key="text">
          <h2 className="sd-h2">{p.title}</h2>
          <p>{p.body}</p>
        </div>
      );

      const image = (
        <div className="sd-card-img" key="image">
          <img className="sd-img-base" src={p.base} alt="" />
          <img
            className="sd-img-overlay"
            src={p.overlay}
            alt=""
            style={{ '--ow': p.ow, '--ox': p.ox, '--oy': p.oy }}
          />
        </div>
      );

      return (
        <div
          className={`sd-card ${imageRight ? 'sd-card--img-right' : 'sd-card--img-left'}`}
          key={p.id}
        >
          <div className="sd-card-grid">
            {imageRight ? [text, image] : [image, text]}
          </div>
        </div>
      );
    })}
  </div>
);

export default Panels;
